module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/4-77360c9467faa8a5db4e513a779919fb.jpg";